import { Stack } from '@src/types/Stacks';
import React from 'react';
import StackView from '../StackView';
import StackActionButton from './StackActionButton';
import StackEmptyState from './StackEmptyState';

interface StackContentProps {
  defaultStack: Stack | null | undefined;
  isAdmin: boolean;
  onActionClick: () => void;
}

const StackContent: React.FC<StackContentProps> = ({
  defaultStack,
  isAdmin,
  onActionClick,
}) => {
  const hasDefaultStack = Boolean(defaultStack);

  if (hasDefaultStack) {
    return (
      <>
        {isAdmin && (
          <StackActionButton hasDefaultStack={true} onClick={onActionClick} />
        )}
        <StackView stack={defaultStack} isDefault={true} />
      </>
    );
  }

  return <StackEmptyState isAdmin={isAdmin} onActionClick={onActionClick} />;
};

StackContent.displayName = 'StackContent';

export default React.memo(StackContent);
